<template>
  <div class="page-container pt-3 pb-4 error-page d-flex flex-row align-items-center">
    <div class="text-center w-100">
      <div class="title">
        <h1 class="text-center">{{ $t('heading') }}</h1>
      </div>
      <div class="text-center">{{ $t('content') }}</div>
    </div>
  </div>
</template>
<script>
export default {
  metaInfo() {
    return { title: this.$_t('pages:500.meta') };
  },
  i18nOptions: {
    namespaces: 'pages',
    keyPrefix: '500',
  },
};
</script>